import React from 'react';

import { Empty as EmptyPage } from '@vyaguta/vyaguta-ui';

interface Props {
  message?: string;
  children?: React.ReactNode;
  className?: string;
}

const Empty: React.FC<Props> = ({ message = 'No data to show.', children, className }) => {
  return (
    <EmptyPage message={message} className={className}>
      {children}
    </EmptyPage>
  );
};

export default Empty;
